// extracted by mini-css-extract-plugin
export default {"control":"product-page_control__nBDo4","root":"product-page_root__ptVCZ"};